import React, { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  condition: boolean | undefined;
  fallBack?: ReactNode;
}

const RenderIf: FC<Props> = ({ children, condition, fallBack = null }) => {
  return <>{condition ? children : fallBack}</>;
};

export default RenderIf;
